export default () => ({
    ages16to27: '16-27',
    ages28to49: '28-49',
    ages50to65: '50-65',
    ages65plus: '65+',
    preferNotToSay: 'Prefer not to say',
})